import { render, staticRenderFns } from "./CapacitiesView.vue?vue&type=template&id=1873688b&scoped=true"
import script from "./CapacitiesView.vue?vue&type=script&lang=js"
export * from "./CapacitiesView.vue?vue&type=script&lang=js"
import style0 from "./CapacitiesView.vue?vue&type=style&index=0&id=1873688b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1873688b",
  null
  
)

export default component.exports